import "./_aboutsection.scss";
import TrackPlayer from "../../AudiobooksContainer/TrackPlayer/TrackPlayer";

const AboutSection = (props) => {

    return (
        <section>
            <h2>A propos</h2>
            <h3>Quelques lignes pour en savoir plus</h3>
            <div className="about-container">
                <img src="./assets/images/profil_picture/profile-picture.jpeg" alt="Arthur Le Meur"/>
                <div className="about-description">
                    <p>
                        Diplômé d’un Bachelor en Réalisation Sonore à l’EICAR, je compose des musiques originales pour l’image et le récit.
                        <br/><br/>
                        Fiction, documentaire, livre audio, publicité ou jingle : chaque projet est l’occasion d’explorer une nouvelle ambiance, un nouveau langage sonore.
                        <br/><br/>
                        Grâce à l’utilisation d’instruments virtuels professionnels et à une approche soignée de la narration musicale, je propose des compositions sur mesure, efficaces et expressives.
                        <br/><br/>
                        Mon objectif : mettre la musique au service de l’émotion et de l’intention visuelle. Réactif, à l’écoute, et impliqué dans chaque collaboration, je cherche toujours à créer une musique juste, évocatrice, qui soutient et enrichit l’image ou le récit.
                        <br/><br/>
                        Mes inspirations sont multiples : du souffle orchestral d’Hans Zimmer à la finesse mélodique d’Alexandre Desplat, en passant par des univers plus contemporains comme le rock, l’électro ou le rap. Cette diversité nourrit ma créativité et me permet de m’adapter avec fluidité à l’esthétique et aux intentions de chaque projet.
                    </p>
                </div>
            </div>
            <TrackPlayer
                currentTrack={{
                    "title":"Medley",
                    "artist": "Arthur Le Meur",
                    "album": "",
                    "audio":"/assets/audio/random/Medlay_Getinshoot.mp3",
                    "cover": "/assets/images/music-covers/cover_7.jpeg",
                    "duration": "02:45"
                }}
                key={"Medley"}
                activeTrackId={props.activeTrackId}
                setActiveTrackId={props.setActiveTrackId}
                onTrackEnd={props.onTrackEnd}
            />

        </section>
    )
}

export default AboutSection;